import type { MetricLegacy, PagePredictions, Source } from '@netpurpose/types'
import type { AxiosInstances } from '../../client'
import { joinPaths } from '../../utils'
import { SimpleAbstractModelApi } from '../SimpleAbstractModelApi'
import { formatSource } from './formatSource'
import {
  type BackendPagePredictions,
  type BackendSource,
  parsePagePredictions,
  parseSource,
  reverseSourceFieldMap,
} from './parseSource'

export default class SourceApi extends SimpleAbstractModelApi<BackendSource, Source> {
  endpoint = '/sources'
  modelFormatter = formatSource
  reverseFieldMap = reverseSourceFieldMap

  constructor(axiosInstances: AxiosInstances) {
    super(axiosInstances, parseSource)
    this.getPagePredictions = this.getPagePredictions.bind(this)
  }

  async getPagePredictions(
    sourceId: Source['id'] | null,
    metricId: MetricLegacy['id'] | undefined,
  ): Promise<PagePredictions | null> {
    if (!sourceId || !metricId) {
      return Promise.reject(
        new Error(
          `Cannot get page predictions with a source id of ${sourceId} and a metric Id of ${metricId}.`,
        ),
      )
    }
    const { data } = await this.api.get<BackendPagePredictions>(
      joinPaths(this.endpoint, sourceId, 'metric_page_predictions'),
      {
        params: {
          metrics: [metricId],
        },
      },
    )
    return data ? parsePagePredictions(data) : null
  }
}
